import { SPOTLIGHT_PADDING, TRANSITION } from './../constants';
import type { Rect } from './../types';

export default function Spotlight({ rect }: { rect: Rect }) {
  const left = Math.max(0, rect.left - SPOTLIGHT_PADDING);
  const width = Math.min(rect.width + SPOTLIGHT_PADDING * 2, window.innerWidth);

  return (
    <div
      className="border-primary-500 pointer-events-none fixed z-9999 rounded-lg border-2"
      style={{
        top: rect.top - SPOTLIGHT_PADDING,
        left,
        width,
        height: rect.height + SPOTLIGHT_PADDING * 2,
        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.7)',
        transition: TRANSITION,
      }}
    />
  );
}
